// extracted by mini-css-extract-plugin
export default {"ContainerApp":"App_ContainerApp__FYzgC"};